export default function getCumulativeSum(nums: number[], idx: number): number {
  return nums.slice(0, idx + 1).reduce((acc, val) => acc + val, 0);
}
